import React from "react";

const ClientNotesHistory = ({ notesHistory }) => {
  return (
    <section className="tw-container tw-mx-auto tw-p-5 tw-bg-white tw-rounded-[10px] tw-shadow-md">
      <h3 className="tw-text-xl tw-font-semibold tw-text-red-600 tw-mb-4 tw-border-b tw-pb-2">
        Notes History
      </h3>
      <div className="tw-overflow-x-auto">
        {notesHistory.length == 0 ? (
          <p>No data is available in the notes history.</p>
        ) : (
          <table className="tw-min-w-full tw-bg-white tw-rounded-lg tw-shadow-md">
            <thead className="tw-whitespace-nowrap">
              <tr>
                <th className="tw-px-4 tw-py-2 tw-text-left tw-text-xs tw-font-semibold tw-text-primary tw-uppercase tw-tracking-wider">
                  No
                </th>
                <th className="tw-px-4 tw-py-2 tw-text-left tw-text-xs tw-font-semibold tw-text-primary tw-uppercase tw-tracking-wider">
                  Creation Date
                </th>
                <th className="tw-px-4 tw-py-2 tw-text-left tw-text-xs tw-font-semibold tw-text-primary tw-uppercase tw-tracking-wider">
                  creation by
                </th>
                <th className="tw-px-4 tw-py-2 tw-text-left tw-text-xs tw-font-semibold tw-text-primary tw-uppercase tw-tracking-wider">
                  notes for partner
                </th>
                <th className="tw-px-4 tw-py-2 tw-text-left tw-text-xs tw-font-semibold tw-text-primary tw-uppercase tw-tracking-wider">
                  notes for admin
                </th>
              </tr>
            </thead>
            <tbody>
              {notesHistory?.map((note, index) => (
                <tr key={index} className="tw-border-b tw-border-gray-200">
                  <td className="tw-px-4 tw-py-2 tw-whitespace-nowrap tw-text-sm tw-font-medium tw-text-gray-900">
                    {index + 1}
                  </td>
                  <td className="tw-px-4 tw-py-2 tw-whitespace-nowrap tw-text-sm tw-text-gray-500">
                    {note.adminActionDate}
                  </td>
                  <td className="tw-px-4 tw-py-2 tw-whitespace-nowrap tw-text-sm tw-text-gray-500">
                    {note.adminName}
                  </td>
                  <td className="tw-px-4 tw-py-2 tw-whitespace-nowrap tw-text-sm tw-text-gray-500">
                    {note.notesForPartner}
                  </td>
                  <td className="tw-px-4 tw-py-2 tw-whitespace-nowrap tw-text-sm tw-text-gray-500">
                    {note.notesForAdmin}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </section>
  );
};

export default ClientNotesHistory;
